(() => {
  if (window.rzProductBuyFocusReady) return;
  window.rzProductBuyFocusReady = true;
  // The theme restores focus after replacing variant controls using focus(),
  // which scrolls to the hidden radio. Restore it without scrolling instead.
  document.addEventListener('product:rerender', event => {
    if (event.detail?.productChange) return;
    const purchaseArea = event.target.closest?.('.rz-product-buy');
    const fragment = event.detail?.htmlFragment;
    if (purchaseArea && fragment?.querySelectorAll) {
      // Same-price sizes should not remount the price/tax container. This also
      // avoids retriggering widgets watching for newly inserted price nodes.
      const signature = block => {
        const fields = ['sale-price', 'compare-at-price', 'unit-price'];
        const values = fields.map(selector => {
          const node = block.querySelector(selector);
          return node ? node.textContent.replace(/\s+/g, ' ').trim() : null;
        });
        const tax = block.querySelector('price-list')?.nextElementSibling;
        values.push(tax?.tagName === 'P' ? tax.innerHTML : null);
        return JSON.stringify(values);
      };
      const rerender = event.target.closest('product-rerender');
      const incoming = [...fragment.querySelectorAll('product-rerender')].find(node => node.id === rerender?.id);
      if (incoming) {
        purchaseArea.querySelectorAll('[data-block-type="price"]').forEach(current => {
          const next = [...incoming.querySelectorAll('[data-block-type="price"]')].find(node => node.dataset.blockId === current.dataset.blockId);
          if (next && current.querySelector('sale-price') && signature(current) === signature(next)) next.remove();
        });
      }
    }
    const active = document.activeElement;
    const area = active?.closest('.rz-product-buy');
    if (!area || !active.id || !active.closest('variant-picker, quantity-selector')) return;
    if (!area.contains(event.target)) return;
    const id = active.id;
    active.blur();
    queueMicrotask(() => {
      const replacement = document.getElementById(id);
      if (replacement && area.contains(replacement)) replacement.focus({preventScroll:true});
    });
  }, true);
})();
